import { Button, Stack, Typography } from "@mui/material";
import {
  CalendarMonth,
  CheckCircle,
  AccessTime,
  MedicalServices,
  People,
} from "@mui/icons-material";

interface IProps {
  selectedView: string;
  onSelectView: (view: string) => void;
  cards: any[];
}

export function ScheduleSelectionCards({
  selectedView,
  onSelectView,
  cards,
}: IProps) {
  return (
    <Stack spacing={1} direction="row" width="100%">
      {cards.map((card) => {
        const Icon = card.icon;
        const isSelected = selectedView === card.id;

        return (
          <Button
            key={card.id}
            onClick={() => onSelectView(card.id)}
            variant={isSelected ? "contained" : "text"}
            sx={{
              justifyContent: "flex-start",
              py: 1.5,
              px: 2,
              textTransform: "none",
              borderRadius: 1,
              color: isSelected ? "white" : "text.primary",
            }}
            startIcon={
              <Icon
                sx={{
                  fontSize: 20,
                  color: isSelected ? "white" : "primary.main",
                }}
              />
            }
          >
            <Typography variant="body1" fontWeight={isSelected ? 500 : 400}>
              {card.title}
            </Typography>
          </Button>
        );
      })}
    </Stack>
  );
}
